import {Component, TemplateRef, ViewContainerRef, computed, inject, signal} from '@angular/core';
import {FixedScheduleToPlan} from '@domain/planning-prototype/to-plan/fixed-schedule-to-plan';
import {AssertionUtils} from '@vdw/angular-component-library';
import {PlanningItemDragDropService} from '../../utilities/planning-item-drag-drop.service';
import {PlanningPrototypeContextService} from '../../utilities/planning-prototype-context.service';

@Component({
  selector: 'app-fixed-schedules-sidebar',
  templateUrl: './fixed-schedules-sidebar.component.html',
  styleUrls: ['./fixed-schedules-sidebar.component.scss']
})
export class FixedSchedulesSidebarComponent {
  private readonly planningContext = inject(PlanningPrototypeContextService);
  private readonly planningDragDrop = inject(PlanningItemDragDropService);
  private readonly viewContainer = inject(ViewContainerRef);

  public readonly nameFilter = signal<string>(null);
  public readonly filteredFixedSchedules = computed(() =>
    this.planningContext.fixedSchedulesToPlan.filter((x: FixedScheduleToPlan) => AssertionUtils.isNullOrUndefined(this.nameFilter()) || x.name.toLowerCase().includes(this.nameFilter().toLowerCase()))
  );

  public closeMachineDetail(): void {
    this.planningContext.selectItem(null);
  }

  public onDragStart(event: DragEvent, schedule: FixedScheduleToPlan, template: TemplateRef<any>): void {
    this.planningDragDrop.onDragStart(event, schedule, template, this.viewContainer);
  }
}
